import React from "react";
import AdminEntityList from "@/components/admin/AdminEntityList";

const fields = [
  { key: "name", label: "Name", required: true },
  { key: "slug", label: "Slug (auto if empty)" },
  { key: "role", label: "Role" },
  { key: "company", label: "Company" },
  { key: "industry_slug", label: "Industry slug" },
  { key: "location", label: "Location" },
  { key: "portrait", label: "Portrait image URL" },
  { key: "short_bio", label: "Short bio", type: "textarea", rows: 3 },
  { key: "biography", label: "Full biography", type: "textarea", rows: 6 },
  { key: "years_operating", label: "Years operating", type: "number" },
  { key: "topics", label: "Topics (list of slugs)", type: "list" },
  { key: "areas", label: "Areas", type: "list" },
  { key: "principles", label: "Operating principles", type: "list" },
  { key: "website", label: "Website" },
  { key: "linkedin", label: "LinkedIn" },
];

export default function AdminOperators() {
  return (
    <AdminEntityList
      title="Operators"
      endpoint="/admin/operators"
      listEndpoint="/operators"
      fields={fields}
      testIdBase="admin-operators"
    />
  );
}
